import CustomModal from "../CustomModal";

const ViewStaffModal = ({
  isOpen,
  onRequestClose,
  selectedAdmin,
  passwordInput,
  handlePasswordChange,
  handlePasswordSubmit,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="View Admin Modal"
      className="view-staff-modal"
    >
      {selectedAdmin && (
        <div>
          <div className="enter-password">
            <h2>Enter Password</h2>
          </div>

          <p>Enter super admin password to view staff's details</p>
          <form onSubmit={handlePasswordSubmit} className="view-staff-form">
            <label htmlFor="password">Password:</label>
            <br />
            <input
              type="password"
              id="password"
              name="password"
              value={passwordInput}
              onChange={handlePasswordChange}
              required
              autoComplete="new-password"
              autoFill="off"
              data-lpignore="true"
              spellCheck="false"
            />
            <div className="modal-button">
              <button type="button" onClick={onRequestClose}>
                Back
              </button>
              <button type="submit">View Details</button>
            </div>
          </form>
        </div>
      )}
    </CustomModal>
  );
};

export default ViewStaffModal;
